import { render, staticRenderFns } from "./control2Content.vue?vue&type=template&id=1e77beb4&scoped=true&"
import script from "./control2Content.vue?vue&type=script&lang=js&"
export * from "./control2Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77beb4",
  null
  
)

export default component.exports